import gql from 'graphql-tag'

export default gql`
mutation updateParticipant($record:UpdateByIdParticipantInput!){
    updateParticipant(record:$record){
      recordId
    }
  }`
